/**
 * Group chat paging (owner decision 2026-10-08): the newest CHAT_PAGE_SIZE
 * messages live, older ones CHAT_PAGE_SIZE at a time when the reader scrolls
 * to the top. The live listener just widens its limit, so older messages stay
 * live too (soft-deletes, replies). Pure, no Firebase.
 */

export const CHAT_PAGE_SIZE = 50;

/** Load an older page once the reader is this close to the top (px). */
export const LOAD_OLDER_THRESHOLD_PX = 80;

/** A full page came back: there may be older messages. */
export function hasOlderMessages(received: number, limit: number): boolean {
  return received >= limit;
}

export function nextChatLimit(limit: number): number {
  return limit + CHAT_PAGE_SIZE;
}

export function shouldLoadOlder(input: { offsetY: number; hasMore: boolean; loading: boolean }): boolean {
  return input.hasMore && !input.loading && input.offsetY <= LOAD_OLDER_THRESHOLD_PX;
}

/**
 * Where to scroll after older messages were added above, so the message the
 * reader was looking at stays in place.
 */
export function offsetAfterPrepend(anchor: { height: number; offset: number }, newHeight: number): number {
  return Math.max(0, newHeight - anchor.height + anchor.offset);
}
